import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ms-generic-card-component',
  templateUrl: './generic-card-component.component.html',
  styleUrls: ['./generic-card-component.component.scss']
})
export class GenericCardComponentComponent implements OnInit {

  @Input() cardTitle:string;
  @Input() cardContentTitle:string
  @Input() imgUrl:string
  @Input() buttonText:string
  @Input() navigateAbsolutPath:string
  @Output() buttonClicked = new EventEmitter<boolean>();

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public navigate(){
    if(this.navigateAbsolutPath.length == 0) {
      this.buttonClicked.emit(true);
    }
    else 
    this.router.navigate([`${this.navigateAbsolutPath}`]);
  }
}
